"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 * Obtiene la serie de preguntas necesarias para proseguir en la Guardia Médica
 *
 * @param firestore
 * @param symptom síntoma del paciente, debe estar en minúscula
 */
function useAssementBySymptoms(firestore, symptom) {
    const AssementsRef = (0, firestore_2.collection)(firestore, "/parametros/userapp", "assessment");
    const AssementsQuery = (0, firestore_2.query)(AssementsRef, (0, firestore_2.where)("triggers", "array-contains-any", symptom));
    return (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.WithoutCategory({
        name: "AssementsRef",
        path: "parametros/userapp/assessment"
    }, [symptom]), AssementsQuery, {}, {});
}
exports.default = useAssementBySymptoms;
